<script>
import API from '@/api'
import {mapGetters} from "vuex"
import setting from "@/setting"

export default {
    name: "ToolTips",
    data() {
        return {
            setting,
            hasVideo: false,
            videoUrl: null,
            toolTipStyle: {
                top: '0px',
                left: '0px',
            },
            loading: false,
            game: null,
            pitch: null,
            energy_name: {
                'UT':'胸郭',
                'HND':'手',
                'LT':'骨盤',
                'FA':'前腕',
                'UA':'上腕',
            },
            energy_transfer_name: {
                'LT2UT':'骨盤⇒胸郭',
                'UA2FA':'上腕⇒前腕',
                'FA2HND':'前腕⇒手',
                'UT2UA':'胸郭⇒上腕',
            },
            pitchTunnel: setting.accessControl.pitchTunnel,
        }
    },
    computed: {
        ...mapGetters(['toolTip','listOfTeams'])
    },
    watch: {
        toolTip(val) {
            this.videoUrl = null
            this.getVideo(val.ID)
            this.showTooltipAt(val.event)
        }
    },
    mounted() {
        document.addEventListener('click', this.handleClickOutside)
        this.showTooltipAt(this.toolTip.event)
        this.getVideo(this.toolTip.ID)
        console.log('mounted', this.toolTip)
    },
    beforeUnmount() {
        document.removeEventListener('click', this.handleClickOutside)
    },
    methods: {
        handleClickOutside(event) {
            const tooltip = this.$refs.tooltip
            const videoModal = document.querySelector('.video-modal')
            if (videoModal && (event.target === videoModal || videoModal.contains(event.target))) {
                return
            }
            if (tooltip && !tooltip.contains(event.target)) {
                this.$store.commit('setToolTip',null)
            }
        },
        showTooltipAt(event) {

            if (event) {
                const tooltipWidth = this.$refs.tooltip.offsetWidth // Get the actual tooltip width
                const tooltipHeight = this.$refs.tooltip.offsetHeight // Get the actual tooltip height
                const offset = 10 // 10px offset for better positioning
                const windowWidth = window.innerWidth
                const windowHeight = window.innerHeight

                let leftPosition = event.clientX + offset
                if (leftPosition + tooltipWidth > windowWidth) {
                    leftPosition = event.clientX - tooltipWidth - offset
                }

                let topPosition = event.clientY + offset
                if (topPosition + tooltipHeight > windowHeight) {
                    topPosition = event.clientY - tooltipHeight - offset
                }

                this.toolTipStyle = {
                    top: `${topPosition}px`,
                    left: `${leftPosition}px`,
                }
            }
        },


        showVideo() {
            this.$store.commit('setVideo',{
                data: this.pitch,
                url: this.videoUrl,
                game: this.game,
                isBatter: this.toolTip.isBatter,
            })
        },
        getVideo(id) {
            this.hasVideo = false
            this.loading = true
            API.PITCHES.getVideo(id, (res) => {
                if (res?.url) {
                    this.hasVideo = true
                    this.videoUrl = res.url
                    this.game = res.game
                    this.pitch = res.pitch
                }
            },
            (err) => {
                if (err.status !== 404) {
                    console.log(err)
                }
            }).finally(() => {
                this.loading = false
            })
        },

        addPitchTunnel (data) {
            switch (data.pitchingdata.TaggedPitchType) {
            case 'Fastball':
            case 'Sinker':
            case 'Cutter':
                break
            default:
                return
            }

            const tabData = this.$ls.get(setting.sessionKey.pt1Tabs)
            if (tabData.data.length >= 5) {
                this.$confirm('ピッチトンネルが作成できません。<br>' +
                    '作成できる件数は最大5件ですので \n既存のピッチトンネルのデータを削除してください。<br>' +
                    'PT1に遷移しますか？', () => {
                    this.$router.push('./three?tunnel')
                })
                return
            }

            const allNameList = this.$p.get(data.pitchingdata.PitcherTeam)
            const arm = (() => {
                if (data.pitchingdata.PitcherThrows === 'Right') return '右'
                else if (data.pitchingdata.PitcherThrows === 'Left') return '左'
                else return ''
            })()

            const date = this.$d(data.pitchingdata.Date)
            const pt2Data = {
                selectedYear: date.format('YYYY'),
                selectedMonth: date.format('MM'),
                selectedLeague: this.listOfTeams[data.pitchingdata.PitcherTeam].league,
                teams: [{
                    value: data.pitchingdata.PitcherTeam,
                    text: this.listOfTeams[data.pitchingdata.PitcherTeam].name_short2,
                }],
                selectedLevel: data.pitchingdata.Level,
                selectedTeam: data.pitchingdata.PitcherTeam,
                pitchers: [{
                    value: data.pitchingdata.PitcherId,
                    text: allNameList[data.pitchingdata.PitcherId].name,
                    arm: arm,
                }],
                selectedArm: arm,
                selectedPitcher: data.pitchingdata.PitcherId,
                selectedBall1: data.pitchingdata.TaggedPitchType,
                checkBoxs: [],
                otherScreenAddFlag: true,
                selectedBall1Id: data.id,
            }
            this.initLocalStorage()
            const ptData = this.$ls.get(this.setting.sessionKey.pt1Tabs)
            ptData.index = ptData.data.length
            this.$ls.set(setting.sessionKey.pt1Tabs, ptData)
            this.$ls.set(setting.sessionKey.pt2Search, pt2Data)
            this.$router.push('PitchiTunnelSearch')
        },
        initLocalStorage () {
            // PT2Hシークバー初期化
            this.$ls.set(this.setting.sessionKey.pt2ChangeAmountThresholdSeekBar, {
                ptX: 14.6, // PT円の横幅
                ptY: 14.6, // PT円の縦幅
                hpY: 51.1, // HP円の縦幅
                hpX: 51.1, // HP円の横幅
                ptMaxUp: 29.2, //PT上限値の上の方
                ptMaxDown: 3.65, // PT上限値の下の方
                hpMaxUp: 51.1, // HP上限値の上の方
                hpMaxDown: 10.95, // HP上限値の下の方
                hpDepth: 100,// HP奥行
                ptDepth: 100,// PT奥行
                ptTime: 175, // PT初期値
                cx: 0, // 円x初期値
                cy: 0, //円y初期値
                ptDepthCheck: false, // pt奥行絞り込チェックボックス
                hpDepthCheck: false, // hp奥行絞り込チェックボックス
            })

            // PT2H選択された投球1,2
            this.$ls.set(this.setting.sessionKey.pt2ConfirmationChangeAmountBall1, {})
            this.$ls.set(this.setting.sessionKey.pt2ConfirmationChangeAmountBall2, {})
            // 変化量選定のゾーン等
            this.$ls.set(this.setting.sessionKey.pt2HomeBallContent, {
                selectedZone: [],
                renderBall1: [],
                renderBall2: [],
                thresholdBall2: [],
                dataLoadFlag: false,
            })

            //PT2S シークバー
            this.$ls.set(this.setting.sessionKey.pt2S1ThresholdSeekBar, {
                ptX: 14.6, // PT円の横幅
                ptY: 14.6, // PT円の縦幅
                hpY: 51.1, // HP円の縦幅
                hpX: 51.1, // HP円の横幅
                ptMaxUp: 29.2, //PT上限値の上の方
                ptMaxDown: 3.65, // PT上限値の下の方
                hpMaxUp: 51.1, // HP上限値の上の方
                hpMaxDown: 10.95, // HP上限値の下の方
                hpDepth: 100,// HP奥行
                ptDepth: 100,// PT奥行
                pt: 175, // PT初期値
                cx: 0, // 円x初期値
                cy: 0, //円y初期値
                ptDepthCheck: false, // pt奥行絞り込チェックボックス
                hpDepthCheck: false, // hp奥行絞り込チェックボックス
            })

            // PT2S 選択された投球1,2
            this.$ls.set(this.setting.sessionKey.pt2SSelectedBall1, [])
            this.$ls.set(this.setting.sessionKey.pt2SSelectedBall2, [])

            // 検索コンポーネント関連
            this.$ls.set(this.setting.sessionKey.pt2Search, {})
            this.$ls.set(this.setting.sessionKey.pt2SearchTmp, {})
        },
    },
}
</script>

<template>
    <div
        :id="toolTip.ID"
        ref="tooltip"
        class="toolTip"
        :style="toolTipStyle"
    >
        <span v-if="toolTip.Date">試合日: {{ toolTip.Date }}</span>
        <span v-if="toolTip.Pitcher">投手: {{ toolTip.Pitcher }}</span>
        <span v-if="toolTip.Speed">ボールスピード: {{ toolTip.Speed }}km/h</span>
        <span v-if="toolTip.Spinrate">スピンレート: {{ toolTip.Spinrate }}</span>
        <span v-if="toolTip.ReleaseHeight">リリースの高さ: {{ toolTip.ReleaseHeight.toFixed(1) }}cm</span>
        <span v-if="toolTip.ReleaseWidth"> リリースの横幅: {{ toolTip.ReleaseWidth.toFixed(1) }}cm</span>
        <span v-if="toolTip.Extension"> エクステンション: {{ toolTip.Extension.toFixed(1) }}cm</span>
        <span v-if="toolTip.HorzBreak">横の変化量: {{ toolTip.HorzBreak.toFixed(1) }}cm</span>
        <span v-if="toolTip.VertBreak">縦の変化量: {{ toolTip.VertBreak.toFixed(1) }}cm</span>
        <span v-if="toolTip.Hittype">打球: {{ toolTip.Hittype }}</span>
        <span v-if="toolTip.PitchType">球種: {{ toolTip.PitchType }}</span>
        <span v-if="toolTip.Result">判定結果: {{ toolTip.Result }}</span>
        <span v-if="toolTip.Distance">距離: {{ toolTip.Distance }}m</span>
        <span v-if="toolTip.ExitSpeed">打球速度: {{ toolTip.ExitSpeed }}km/h</span>
        <span v-if="toolTip.Angle">打球角度: {{ toolTip.Angle }}&deg;</span>
        <span v-if="toolTip.Bearing">打球方向: {{ Number(toolTip.Bearing)?.toFixed(2) ?? '' }}</span>
        <span v-if="toolTip.centroid_velocity">重心速度: {{ toolTip.centroid_velocity.toFixed(1) }} m/s</span>
        <span v-if="toolTip.varus_torque">内反トルク: {{ toolTip.varus_torque.toFixed(1) }} Nm</span>
        <template v-if="toolTip.energy">
            <span
                v-for="key in Object.keys(toolTip.energy).filter(x=>toolTip.energy[x]!==null&&!x.includes('original'))"
                :key="key"
            >{{ energy_name[key] }}: {{ toolTip.energy[key].toFixed(1) }} J</span>
        </template>
        <template v-if="toolTip.energy_transfer">
            <span
                v-for="key in Object.keys(toolTip.energy_transfer).filter(x=>toolTip.energy_transfer[x]!==null)"
                :key="key"
            >{{ energy_transfer_name[key] }}: {{ toolTip.energy_transfer[key].toFixed(0) }} %</span>
        </template>
        <div style="display: flex; justify-content: space-between;">
            <button
                v-if="toolTip.btn3DTunnelVisible && pitchTunnel"
                class="btn"
                @click.stop="addPitchTunnel(toolTip.allData)"
            >
                ピッチトンネル
            </button>
            <button
                v-if="toolTip.btn3DVisible"
                class="btn"
                @click.stop="$root.$emit('modal3dOn',toolTip.ID, toolTip.allData, 'atBat')"
            >
                3Dで表示
            </button>

            <div
                v-if="loading"
                class="loading-indicator"
            />
            <button
                v-if="hasVideo"
                class="btn"
                @click.stop="showVideo"
            >
                動画
            </button>
        </div>
    </div>
</template>

<style scoped>
.toolTip {
    position: absolute;
    top: 0;
    left: 0;
    width: 150px;
    font-size: 10px;
    background-color: #fff;
    border: solid 1px #999;
    padding: 5px;
    line-height: 1.3;
    z-index: 10;
    white-space: nowrap;
}

.toolTip > span {
    display: block;
}

.toolTip .btn {
    min-width: 60px;
    height: 20px !important;
    padding: 0;
    margin: 4px 0 0;
    font-size: 1rem;
    min-height: unset;
}

.loading-indicator {
    width: 15px;
    height: 15px;
    border: 4px solid rgba(0, 0, 0, 0.1);
    border-top: 4px solid #6a8fdb;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin: 5px auto;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}
</style>
